import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { FinancingModalityService } from 'src/app/shared/services/core/financing-modality.service';
import { FinanceStatus } from 'src/app/shared/models/financeStatus.model';
import { IPaginatedFilters } from 'src/app/shared/architecture/envelopes';
import { NgxPaginationModule } from 'ngx-pagination';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-mod-finan',
  templateUrl: './mod-finan.component.html',
  styleUrl: './mod-finan.component.scss',
  standalone: true, 
  imports: [TegelModule, CommonModule, NgxPaginationModule]
})
export class ModFinanComponent implements OnInit{
  originalFinancings: FinanceStatus[] = [];
  financings: FinanceStatus[] = [];
  page = 1;
  pageSize = 10;
  searchText = '';
  private filtros:IPaginatedFilters = { paginationValue: '1', paginationSize: '10', columnKey: '', sortingDirection: '', query: ''};
  order = "id";

  constructor(private financingModalityService: FinancingModalityService, private cdr: ChangeDetectorRef){
    this.financings = [];
  }

  ngOnInit(): void {
    this.getAllFinancing();
  }

  getAllFinancing(){
    this.financingModalityService.get().subscribe((result) => {
      if (result){
        this.originalFinancings = result;
        this.financings = result;
        this.cdr.detectChanges();
        console.log(this.financings);
      }
    });
  }


  onFilterEvent(event: any) {
    const rawValue = event?.detail?.query ?? event?.target?.query ?? '';
    const value = String(rawValue).trim().toLowerCase();

    if (!value) {
      this.financings = [...this.originalFinancings];
      this.page = 1;
      return;
    }

    const digits = value.replace(/\D/g, '');

    this.financings = this.originalFinancings.filter(f => {
      const idMatch = digits ? String(f.id).includes(digits) : false;
      const descMatch = f.descricao?.toLowerCase().includes(value);

      return idMatch || descMatch;
    });

    this.page = 1;
  }

  onSortEvent(event: any) {
  const column = event.detail.columnKey;
  const direction = event.detail.sortingDirection; 

  if (!column || direction === 'none') {
    return; 
  }

  
  this.financings.sort((a: any, b: any) => {
    const dir = direction === 'desc' ? 1 : -1;

    if (a[column] > b[column]) return 1 * dir;
    if (a[column] < b[column]) return -1 * dir;
    return 0;
  });
}

  // Teste
  // debugSort(e: any) {
  // console.log('SORT EVENT DISPARADO:', e);
  // }
}
